'use client';
import { setSortingOption } from '@/redux/reducers/sorting.reducer';
import { SortingOptions } from '@/types';

import { useAppDispatch, useAppSelector } from './use-redux.hook';

const useSort = () => {
  const dispatch = useAppDispatch();
  const { field, asc } = useAppSelector((state) => state.sort);

  const setSortOptions = (sortOption: SortingOptions | undefined) => {
    if (!sortOption) return;

    dispatch(setSortingOption(sortOption));
  };

  return {
    setSortOptions,
  };
};
export default useSort;
